import Link from '@/components/Common/Link'
import { StencilCDNImage } from '@/components/Common/StencilImage'

export default function Certification() {
  return (
    <div className="items-between flex flex-col justify-center gap-4 py-6 lg:flex-row">
      <div className="flex flex-shrink-0 flex-col items-center">
        <StencilCDNImage
          src="https://indcdn.indmoney.com/cdn/images/fe/iso-cert-new.png"
          alt="We are a SEBI registered investement advisor"
          width={100}
          height={85}
        />
        <p className="text-brand-grey-base w-44 text-center text-[10px]">
          We hold ISO Information Security Management System ISO/IEC 27001:2022
          certification.
        </p>
      </div>

      <div className="flex flex-shrink-0 flex-col items-center">
        <Link
          openInNewTab
          href="https://seal.panaceainfosec.com/index.php?certid=CERT17F494B703"
        >
          <StencilCDNImage
            src="https://indcdn.indmoney.com/cdn/images/fe/pci-dss-webseal.png"
            alt="We are a SEBI registered investement advisor"
            width={100}
            height={85}
          />
        </Link>

        <p className="text-brand-grey-base mt-7 w-44 text-center text-[10px]">
          INDmoney Tech Private Limited (Formerly known as Finzoom Investment
          Advisors Private Limited). holds PCIDSS certification
        </p>
      </div>

      <div className="flex flex-shrink-0 flex-col items-center">
        <Link
          openInNewTab
          href="https://seal.panaceainfosec.com/index.php?certid=CERTCF523CC949"
        >
          <StencilCDNImage
            src="https://indcdn.indmoney.com/cdn/images/fe/pci-dss-webseal.png"
            alt="We are a SEBI registered investement advisor"
            width={100}
            height={85}
          />
        </Link>

        <p className="text-brand-grey-base mt-7 w-44 text-center text-[10px]">
          INDmoney Tech Private Limited (Formerly known as Finzoom Investment
          Advisors Private Limited) holds PCIDSS certification
        </p>
      </div>
    </div>
  )
}
